<template>
  <v-container grid-list-md pa-0 v-if="user">
    <v-layout row wrap>
      <v-flex xs12>
        <div class="">
          <span class="supporting-text">{{ $d(new Date(user.date), 'short', $i18n.locale) }}</span>
        </div>
        <div class="" v-if="user.name && user.name != ''">
          <span class="text-h6 text-truncate">{{user.name}}</span>
        </div>
        <v-avatar style="margin-top:10px" :size="avatarSize" color="grey lighten-4">
          <img :src="userImg(user.userImage)" />
        </v-avatar>
        <div>
          <div class="text-subtitle-1">
            {{user.fName}} {{user.lName}}
          </div>
          <div v-if="user.belt || user.nationality">
            <belt class="" :show-text="false" v-if="!user.notBjjUser" :size="15" :belt="user.belt" />
            <country-flag size="26" :class="!user.notBjjUser ? 'ml-2' : ''" v-if="user.nationality" :country-code="user.nationality" />
          </div>
          <div
            class="supporting-text"
            v-if="!membersOnly"
          >{{!user.member ? $t('message.visitor') : $t('message.member')}}</div>
          <v-row v-if="user.daysAtBelt && user.daysAtBelt > 0 && user.classesAtBelt && user.classesAtBelt > 0">
            <v-col class="text-right">
              <div class="text-h4">{{user.daysAtBelt}}</div>
              <div class="supporting-text">{{$t('message.days_at_belt')}}</div>
            </v-col>
            <v-col class="text-left">
              <div class="text-h4 mr-1">{{user.classesAtBelt}}</div>
              <div class="supporting-text">{{$t('message.classes_at_belt')}}</div>
            </v-col>
          </v-row>
          <div v-else class="text-center">
            <div v-if="user.daysAtBelt && user.daysAtBelt > 0">
              <span class="supporting-text">{{$t('message.days_at_belt')}}</span>
              <span class="text-h4">{{user.daysAtBelt}}</span>
            </div>
            <div
              v-else-if="user.member && user.classesAtBelt && user.classesAtBelt > 0"
            >
              <span class="supporting-text">{{$t('message.classes_at_belt')}}</span>
              <span class="text-h4">{{user.classesAtBelt}}</span>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Belt from "@/components/displays/BeltDisplay.vue";
import CountryFlag from "@/components/displays/CountryFlagDisplay.vue";

export default {
  props: ["user", "membersOnly"],
  data() {
    return {
      avatarSize: 100,
      fName: null,
      lName: null,
      countryCode: null,
    };
  },
  components: {
    Belt,
    CountryFlag,
  },
  methods: {},
  created() {
    if (this.user) {
      this.fName = this.user.fName;
      this.lName = this.user.lName;
      this.countryCode = this.user.countryCode;
    }
  },
  computed: {},
};
</script>

<style scoped>
</style>
